import PropTypes from 'prop-types'

// Utils
import { cn } from '@/utils/helpers'

function Skeleton({ className, ...props }) {
  return (
    <div
      data-slot="skeleton"
      className={cn('bg-accent animate-pulse rounded-md', className)}
      {...props}
    />
  )
}

Skeleton.propTypes = {
  className: PropTypes.string,
}

export { Skeleton }
